import { StyleSheet } from 'aphrodite';

export const AppTheme = {
  primaryColor: '#1D2331',
  primaryBackground: '#323B4E',
  secondaryColor: '#161C26',
  secondaryColorVariant:'#1E2530',
  white: '#FFFFFF',
  black: '#000000',
  pagePadding: 5,
  fontSizeContent: 12,
  fontSizeTitle: 16,
  actionHeaderbarHeight: 33,
  formFieldHeight: 70,
}

export const AppStyles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.primaryBackground,
  },
  entityTableLinkIcon: {
    padding: 3,
    fontSize: 28,
    color: AppTheme.black,
    cursor: 'pointer'
  },
});
